import { History } from 'lucide-react'
import { Modal } from '../../../componentesCompartilhados/ui/Modal'
import { useHistoricoJob } from '../hooks/useJobs'
import { JobDefinicao } from '../tipos/job'

interface ModalHistoricoJobProps {
  isOpen: boolean
  job: JobDefinicao | null
  onClose: () => void
}

const formatarData = (valor?: string | null) => {
  if (!valor) return '-'
  const data = new Date(valor)
  if (Number.isNaN(data.getTime())) return '-'
  return data.toLocaleString('pt-BR')
}

const corStatus = (status: string) => {
  const lower = status.toLowerCase()
  if (lower === 'concluido') return 'bg-green-100 text-green-700'
  if (lower === 'falhou') return 'bg-red-100 text-red-700'
  if (lower === 'emprocessamento') return 'bg-blue-100 text-blue-700'
  if (lower === 'pendente') return 'bg-yellow-100 text-yellow-700'
  return 'bg-gray-100 text-gray-700'
}

export function ModalHistoricoJob({ isOpen, job, onClose }: ModalHistoricoJobProps) {
  const { data: historico = [], isLoading } = useHistoricoJob(isOpen ? job?.id ?? null : null, 20)

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={job ? `Histórico: ${job.nome}` : 'Histórico'}
      subtitle="Últimas 20 execuções"
      icon={(
        <div className="w-10 h-10 bg-brand-100 text-brand-600 rounded-lg flex items-center justify-center flex-shrink-0">
          <History className="w-5 h-5" />
        </div>
      )}
      size="2xl"
    >
      {isLoading && (
        <div className="text-center py-8 text-sm text-gray-600">Carregando histórico...</div>
      )}
      {!isLoading && historico.length === 0 && (
        <div className="text-center py-8 text-sm text-gray-600">Nenhuma execução registrada.</div>
      )}
      {!isLoading && historico.length > 0 && (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Status</th>
                <th className="px-4 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Criado em</th>
                <th className="px-4 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Início</th>
                <th className="px-4 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Fim</th>
                <th className="px-4 py-2 text-left font-medium text-gray-500 uppercase tracking-wider">Resumo</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {historico.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="px-4 py-2 whitespace-nowrap">
                    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${corStatus(item.status)}`}>
                      {item.status}
                    </span>
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap text-gray-700">{formatarData(item.dataCriacao)}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-gray-700">{formatarData(item.dataInicio)}</td>
                  <td className="px-4 py-2 whitespace-nowrap text-gray-700">{formatarData(item.dataFim)}</td>
                  <td className="px-4 py-2 text-gray-700 max-w-md">
                    {item.mensagemErro && (
                      <div className="text-red-600 text-xs mb-1">{item.mensagemErro}</div>
                    )}
                    {item.resumoJson && (
                      <pre className="bg-gray-50 p-2 rounded text-xs overflow-x-auto">{item.resumoJson}</pre>
                    )}
                    {!item.mensagemErro && !item.resumoJson && '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>
  )
}
